import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const reassurances = [
  { icon: "ri-time-line", text: "Intervention sous 24h" },
  { icon: "ri-file-list-3-line", text: "Devis ferme avant intervention" },
  { icon: "ri-box-3-line", text: "Pièce comprise" },
  { icon: "ri-shield-check-line", text: "Toutes marques" },
];

export default function Hero() {
  return (
    <section className="relative mt-16 md:mt-20 min-h-[420px] md:min-h-[600px] h-auto flex flex-col">
      {/* Fond photo */}
      <div className="absolute inset-0">
        <ImagePlaceholder
          src="https://readdy.ai/api/search-image?query=Professional%20technician%20repairing%20a%20roller%20shutter%20on%20a%20residential%20house%20exterior%2C%20wearing%20work%20uniform%20with%20tools%2C%20warm%20daylight%2C%20clean%20modern%20French%20suburban%20setting%2C%20realistic%20service%20photography%20showing%20quality%20craftsmanship%2C%20professional%20repairman%20at%20work%2C%20editorial%20style%20with%20natural%20colors%20and%20soft%20lighting&width=1600&height=900&seq=hero-reparateur-2026&orientation=landscape"
          alt="Tarifs devis et outils de réparation de volet roulant"
          className="absolute inset-0 w-full h-full"
          loading="eager"
          fetchpriority="high"
        />
        <div className="absolute inset-0 bg-[#143A66]/70"></div>
      </div>

      {/* Contenu principal — colonne centrée */}
      <div className="relative z-10 flex-1 flex items-center w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto w-full flex flex-col items-center text-center">

          {/* ── Colonne centrale ── */}
          <div className="flex flex-col items-center">
            {/* Pastille */}
            <div className="inline-flex items-center gap-2 bg-[#00B3A4]/20 backdrop-blur-sm text-[#E0F7F5] px-4 py-2 rounded-full text-sm font-semibold mb-3 md:mb-5 w-fit animate-hero-fade-up">
              <i className="ri-map-pin-line text-[#5DCAA5]"></i>
              Strasbourg &amp; tout le Bas-Rhin
            </div>

            {/* H1 */}
            <h1 className="text-2xl md:text-5xl font-bold text-white leading-tight mb-3 md:mb-5 animate-hero-fade-up animate-delay-100">
              Réparation de volet roulant à Strasbourg{" "}
              <span className="text-[#5DCAA5]">à partir de&nbsp;69&nbsp;€</span>
            </h1>

            {/* Sous-titre */}
            <p className="text-[#D4DDE6] text-base md:text-lg leading-relaxed mb-5 md:mb-8 animate-hero-fade-up animate-delay-100 max-w-[540px]">
              Des prix clairs, annoncés avant toute intervention. Diagnostic et déplacement gratuits, pièce comprise.
            </p>

            {/* Boutons */}
            <div className="flex flex-col sm:flex-row items-center gap-4">
              <a
                href="tel:0374473240"
                className="inline-flex items-center justify-center gap-2 bg-brand-cyan text-white px-5 py-3 md:px-8 md:py-4 rounded-full font-semibold text-base hover:bg-brand-cyan/90 transition-all duration-200 btn-hover-effect whitespace-nowrap animate-hero-fade-up animate-delay-300"
              >
                <span className="btn-icon-wrap"><i className="ri-phone-line text-lg"></i></span>
                Appeler le 03 74 47 32 40
              </a>
              <a
                href="#devis"
                className="inline-flex items-center justify-center gap-2 border-2 border-white/60 text-white px-5 py-3 md:px-8 md:py-4 rounded-full font-semibold text-base hover:bg-white/10 transition-all duration-200 btn-hover-effect whitespace-nowrap animate-hero-fade-up animate-delay-400"
              >
                Devis gratuit
              </a>
            </div>
          </div>

        </div>
      </div>

      {/* ── Bande de réassurance — pleine largeur ── */}
      <div className="relative z-10 w-full border-t border-white/20">
        <div className="max-w-6xl mx-auto px-4 md:px-8 lg:px-12 py-4 md:py-5">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 animate-hero-fade-up animate-delay-500">
            {reassurances.map((r) => (
              <div key={r.text} className="flex items-center gap-2">
                <i className={`${r.icon} text-[#5DCAA5] text-sm`}></i>
                <span className="text-[#D4DDE6] text-sm leading-tight">{r.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}